import React, { useCallback } from 'react'

import { ModalConfirmIssuanceNote } from 'components/ModalConfirmIssuanceNote'

import { useDisclosure } from '@chakra-ui/react'

import { ActionProps } from './types'
import { WrapperAction } from './WrapperAction'
import { BsReceiptCutoff } from 'react-icons/bs'
import { get } from 'lodash'

export const ConfirmIssuanceNoteAction = <T extends unknown>({
  record,
  options,
}: ActionProps<T>) => {
  const modalConfirmIssuanceNoteDisclosure = useDisclosure()

  const { callback, actionType = 'menu', reload, ...optionsRest } = options

  if (!reload) {
    throw new Error('reload is required')
  }

  const cta = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, data: T) => {
      modalConfirmIssuanceNoteDisclosure.onOpen()

      if (callback) {
        callback(e, data)
      }
    },
    [modalConfirmIssuanceNoteDisclosure, callback]
  )

  return (
    <>
      <ModalConfirmIssuanceNote
        reload={reload}
        purchaseId={get(record, 'id')}
        isOpen={modalConfirmIssuanceNoteDisclosure.isOpen}
        onCancel={modalConfirmIssuanceNoteDisclosure.onClose}
      />

      <WrapperAction
        cta={cta}
        record={record}
        options={optionsRest}
        icon={BsReceiptCutoff}
        actionType={actionType}
        label={'Confirmar emissão da nota fiscal'}
      />
    </>
  )
}
